import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { Spinner } from "spin.js";

let SpinnerClassOptions = {
  spinnerOptions: {
    lines: 13, // The number of lines to draw
    length: 4, // The length of each line
    width: 3, // The line thickness
    radius: 7, // The radius of the inner circle
    corners: 1, // Corner roundness (0..1)
    rotate: 0, // The rotation offset
    direction: 1, // 1: clockwise, -1: counterclockwise
    color: "#fff", // #rgb or #rrggbb or array of colors
    speed: 1, // Rounds per second
    trail: 60, // Afterglow percentage
    shadow: false, // Whether to render a shadow
    hwaccel: false, // Whether to use hardware acceleration
    className: "spinner", // The CSS class to assign to the spinner
    zIndex: 2e9, // The z-index (defaults to 2000000000)
    top: "50%", // Top position relative to parent
    left: "50%" // Left position relative to parent
  },
  defaultTargetClass: "progress"
};

class SpinnerClass extends Class {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.setOptions(SpinnerClassOptions, options);
    this.setupSpinner();
  }

  setupSpinner() {
    var self = this;
    this.spinner = new Spinner(this.options.spinnerOptions).spin();
    $(this.spinner.el).addClass(this.options.defaultTargetClass);
    this.element.append(this.spinner.el);
  }

  hide() {
    // modify spin class stop method to remove all instances
    $(`.${this.options.defaultTargetClass}`).remove();
  }
}

export { SpinnerClass };



// WEBPACK FOOTER //
// ./Javascript/core/classes/spinner.class.js